import React, { useState, useContext } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Delete.module.css'
import { AppContext } from '../../../../providers/appProvider';
import Remove from "../../../../assets/Icon/Remove";
import { useTranslation } from 'react-i18next';

const Delete = ({ taskService, defaultTask }) => {
    const {t} = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appState, app } = useContext(AppContext);

    const confirmDelete = () => { 
        taskService.remove(defaultTask.id)
            .then((response) => {
                setIsModalOpen(false)
            })
            .catch((error) => {
                setIsModalOpen(false)
                app.setError("შეცდომა წაშლისას")
            });
    };

    const openDelete = () => {
        setIsModalOpen(true)
    }

    const closeDelete = () => {
        setIsModalOpen(false)
    }

    return ( <>

            <span className={ cl.removeBtn } onClick={() => openDelete()} ><Remove/> {t('Delete')}</span> 

            <Modal key={defaultTask.id} size="medium" isOpen={isModalOpen} onClose={() => closeDelete()}>
                <div className={cl.modalHead }><h3>{t('Delete')}</h3></div> 
                <div className={ cl.message } >{t('ConfirmDelete')} <b>(#{defaultTask.id})</b></div>
                <div className={ cl.buttons }>
                    <button className={ cl.removeBtnYes } onClick={confirmDelete}>{t('YesIdo')}</button> 
                </div> 
            </Modal>
    

        </> 
    );
};

export default Delete ;